import { Input, Label, Radio } from "@components";
import { Icon } from "shared/components/core/Icon";
import { Environment } from "shared/core/Environment";

const urlTypes = {
  STANDARD: "STANDARD",
  CUSTOM: "CUSTOM",
};

export const UrlType = ({ creative, onChangeCreative }) => {
  const setUrlType = (type) => {
    onChangeCreative({
      url: {
        type: type,
        url:
          type == urlTypes.STANDARD
            ? Environment.defaultShortUrl
            : creative?.url?.url,
      },
    });
  };

  const setUrl = (url) => {
    onChangeCreative({
      url: { type: creative?.url?.type, url: url },
    });
  };

  return (
    <>
      <Label>
        Call to action (CTA)
        <span
          className="ml-10"
          title="Link para onde seu cliente será direcionado"
        >
          <Icon name="info-circle" />
        </span>
      </Label>

      <Radio
        family="url"
        className="mb-10"
        value={urlTypes.STANDARD}
        checked={creative?.url?.type}
        onChange={() => setUrlType(urlTypes.STANDARD)}
      >
        Clube de fidelidade
      </Radio>
      <Radio
        family="url"
        value={urlTypes.CUSTOM}
        checked={creative?.url?.type}
        onChange={() => setUrlType(urlTypes.CUSTOM)}
      >
        Link personalizado
      </Radio>

      {creative?.url?.type === urlTypes.CUSTOM && (
        <Input
          label="Insira a URL"
          design="two"
          autoFocus
          className="mt-30"
          value={creative?.url?.url}
          onChange={(text) => setUrl(text.target.value)}
        />
      )}
    </>
  );
};
